export interface CouponRecovery {
  sourceCode: string;
  docId: string;
  phase: 'price' | 'confirm' | 'confirmed' | 'reconcile';
  orderNumber?: string;
}

const storageKey = (sourceCode: string) =>
  `loyalty-coupon-pending:${sourceCode}`;

// Store only a recovery marker, never a customer phone, coupon code or OTP.
export const readCouponRecovery = (
  sourceCode?: string
): CouponRecovery | null => {
  if (!sourceCode) return null;
  try {
    const value = JSON.parse(
      sessionStorage.getItem(storageKey(sourceCode)) || 'null'
    );
    if (
      value?.sourceCode === sourceCode &&
      (typeof value.docId === 'string' ||
        (typeof value.docId === 'number' && Number.isFinite(value.docId))) &&
      String(value.docId).trim().length > 0 &&
      ['price', 'confirm', 'confirmed', 'reconcile'].includes(value.phase)
    )
      return { ...value, docId: String(value.docId) };
  } catch {
    // A disabled storage cannot provide a marker; writes fail closed below.
  }
  return null;
};

export const saveCouponRecovery = (marker: CouponRecovery) => {
  sessionStorage.setItem(
    storageKey(marker.sourceCode),
    JSON.stringify({ ...marker, docId: String(marker.docId) })
  );
};

export const clearCouponRecovery = (sourceCode?: string) => {
  if (sourceCode) sessionStorage.removeItem(storageKey(sourceCode));
};
